module.exports = __webpack_public_path__ + "img/comercialchi.67d33b5d.png";